<template>
  <v-card
    height="23rem"
    color="background"
    class="d-flex align-center flex-column text-center justify-center"
  >
    <v-card-item>
      <v-row>
        <v-img src="@/shared/assets/addTerminal.png" max-height="150px" min-height="75px" />
      </v-row>
      <v-row class="mx-4">
        <v-card-text class="text-grey-darken-1 text-body-2">
          {{ $t("page.dashboard.addTerminalLandingCard") }}
        </v-card-text>
      </v-row>
      <v-row class="d-flex justify-center">
        <v-btn color="primary" class="my-5" @click="goToReader()">
          {{ $t("common.action.addANewTerminal") }}
        </v-btn>
      </v-row>
    </v-card-item>
  </v-card>
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router";
import type { LocationSummary } from "@/terminals/types/locations";

const props = defineProps<{
  locations?: LocationSummary[];
}>();
const router = useRouter();

const goToReader = () => {
  if (props.locations?.length === 1) {
    router.push({
      path: `/locations/${props.locations[0].id}`,
    });
  } else {
    router.push({
      name: "locations",
    });
  }
};
</script>
